// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2poJj","title":"styles_title__1H6aq"};